import React, { useState, lazy, Suspense } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./body.css";
import htmlParser from "html-react-parser";
import Logo from "../Logo Section/Logo";
import mobilesteps from "../../images/mobilesteps-bg.webp";


export default function Body({bodyData}) {
  
  return (
    <>
   
    <div className="bodysection">
      <Container>
        
        <Row>
          <Col sm={12} className="detailSection">
            <div >
              <h4 className="alltextAnchorMorganeXC">{htmlParser(bodyData.bodyHeading1)}</h4>
              <p className="alltextAnchorMorgan">{htmlParser(bodyData.bodyDetails1)}</p>
            </div>
          </Col>
        </Row>
      </Container>    
      <div className="news-section">
           <Logo />
      </div>
         
      <Container>
        <Row>
         <Col sm={12} className="step-section">
          
          <h4 className="step-sectionheading">{htmlParser(bodyData.bodyHeading2)}</h4>
          <img
                    src={"https://prod-cdn.swmc.com/Influencer/desktop_step_bg.webp"}
                    alt="Steps"
                    className="stepsImg"
                  />
                  <img
                    src={mobilesteps}
                    alt="Steps"
                    className="stepsmobImg"
                  />
              <p className="step1 alltextAnchorMorgan">{htmlParser(bodyData.bodyDetails2)}</p>
              <p className="step2 alltextAnchorMorgan">{htmlParser(bodyData.bodyDetails3)}</p>
              
              <p className="step3">{htmlParser(bodyData.bodyDetails4)}</p>
            
              <p className="stepsSubtext">{htmlParser(bodyData.bodyDetails5)}</p>
              </Col>
        </Row>
      </Container>
    </div>
      
      </>
  );
}
